import React, { useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang';
import { Form } from '../../../components/general/general-component/abstruct-component/AbstructForm';
import { VariableAccounts } from './VariableAccounts';
import { getPageList, postAccount } from '../../../store/Actions/ActionAccounts';
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom';

function AddAccount({ open, setOpen }) {
    let { mode, dispatch, langLocal } = AbstructVar()
    const { page_list, loadingPageList } = useSelectorCustom()
    const { translate } = AbstructLang()
    const { state, setStateCustom, setLoad } = VariableAccounts()
    const Submit = e => {
        e.preventDefault()
        dispatch(postAccount(state, setLoad))
    }
    useEffect(() => {
        dispatch(getPageList())
    }, [])
    const formFields = [
        { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
        { name: 'type', label: 'type_description', type: 'text', inputType: 'text', iconType: "pencil" },
        {
            name: "account_type_id", label: "type", type: "text", inputType: 'one_select', iconType: "user",
            options: page_list?.account_types?.map((type) => ({
                label: type?.name, value: type?.id
            })),
        },
        { name: "amount", label: "amount", type: "text", inputType: 'text', iconType: "pencil" },
        {
            name: "user_id", label: "user_name", type: "text", inputType: 'one_select', iconType: "user",
            options: page_list?.users?.map((user) => ({
                value: user?.id, label: user?.name
            })),
            defaultvaluee: { value: state.user_id, label: state.user_name }
        },
        {
            name: 'status',
            label: 'Status',
            type: 'text',
            inputType: 'one_select',
            iconType: "check",
            options: page_list?.statuses

        },
    ];
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `popupR`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`}>
                <div className={`div_title_popup ${mode === 'dark' ? "darktoppopup" : "lighttoppopup"}`} >
                    <p className={`title_popup ${mode === 'dark' ? "darktext" : "lighttext"}`}  >{translate('add_account')}</p>
                </div>
                <Form langLocal={langLocal} fields={formFields} handleSubmit={Submit} state={state} setStateCustom={setStateCustom} buttonLabel="add" />
            </div>
        </RModal>
    )
}

export default AddAccount
